import { callApi } from './api';

import { Template } from '@/types/template';

export const updateTemplate = async (templateID: number, requestBody: Template) => {
  const { status, result } = await callApi<Template>(
    `templates/${templateID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
